(function () {
  if (customElements.get('cart-drawer')) {
    return;
  }

  const ANIMATION_DURATION = 300;

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleContinueClick = this.handleContinueClick.bind(this);
      this.handleDialogCancel = this.handleDialogCancel.bind(this);
      this.handleDialogClick = this.handleDialogClick.bind(this);
      this.handleDialogClose = this.handleDialogClose.bind(this);
      this.handleOpenRequest = this.handleOpenRequest.bind(this);
      this.openRequestUnsubscribe = null;
      this.isClosing = false;
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog[data-cart-drawer]') || this.querySelector('dialog');
      this.toggles = Array.from(document.querySelectorAll('[data-cart-toggle]'));
      this.closeButton = this.dialog ? this.dialog.querySelector('[data-cart-close]') : null;
      this.continueButton = this.dialog ? this.dialog.querySelector('[data-cart-continue]') : null;

      if (!this.dialog) {
        return;
      }

      this.toggles.forEach((toggle) => toggle.addEventListener('click', this.handleToggleClick));
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.handleCloseClick);
      }
      if (this.continueButton) {
        this.continueButton.addEventListener('click', this.handleContinueClick);
      }
      this.dialog.addEventListener('cancel', this.handleDialogCancel);
      this.dialog.addEventListener('click', this.handleDialogClick);
      this.dialog.addEventListener('close', this.handleDialogClose);

      if (window.themePubsub && typeof window.themePubsub.subscribe === 'function') {
        this.openRequestUnsubscribe = window.themePubsub.subscribe(
          'cart:drawer:open-request',
          this.handleOpenRequest
        );
      }
    }

    disconnectedCallback() {
      if (this.toggles) {
        this.toggles.forEach((toggle) => toggle.removeEventListener('click', this.handleToggleClick));
      }
      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.handleCloseClick);
      }
      if (this.continueButton) {
        this.continueButton.removeEventListener('click', this.handleContinueClick);
      }
      if (this.dialog) {
        this.dialog.removeEventListener('cancel', this.handleDialogCancel);
        this.dialog.removeEventListener('click', this.handleDialogClick);
        this.dialog.removeEventListener('close', this.handleDialogClose);
      }
      if (this.openRequestUnsubscribe) {
        this.openRequestUnsubscribe();
        this.openRequestUnsubscribe = null;
      }
    }

    handleOpenRequest() {
      this.open();
    }

    setExpanded(state) {
      if (!this.toggles) {
        return;
      }
      this.toggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
      });
    }

    open() {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') {
        return;
      }
      if (this.dialog.open && !this.isClosing) {
        return;
      }
      if (!this.dialog.open) {
        this.dialog.showModal();
      }
      this.dialog.classList.remove('is-closing');
      requestAnimationFrame(() => {
        this.dialog.classList.add('is-visible');
        if (window.themePubsub) {
          window.themePubsub.publish('cart:drawer:opened', { dialog: this.dialog });
        }
      });
      this.setExpanded(true);
    }

    close() {
      if (!this.dialog || !this.dialog.open || this.isClosing) {
        return;
      }
      this.isClosing = true;
      this.dialog.classList.remove('is-visible');
      this.dialog.classList.add('is-closing');
      window.setTimeout(() => {
        if (this.dialog.open) {
          this.dialog.close();
        }
        this.isClosing = false;
      }, ANIMATION_DURATION);
    }

    handleToggleClick(event) {
      event.preventDefault();
      this.open();
    }

    handleCloseClick(event) {
      event.preventDefault();
      this.close();
    }

    handleContinueClick(event) {
      event.preventDefault();
      this.close();
    }

    handleDialogCancel(event) {
      event.preventDefault();
      this.close();
    }

    handleDialogClick(event) {
      const panel = this.dialog.querySelector('.cart-drawer__panel');
      if (panel && !panel.contains(event.target)) {
        this.close();
      }
    }

    handleDialogClose() {
      this.dialog.classList.remove('is-visible', 'is-closing');
      this.setExpanded(false);
      if (window.themePubsub) {
        window.themePubsub.publish('cart:drawer:closed', { dialog: this.dialog });
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);
})();
